import { Dealness, FtcType, UtasPolicyHeadline, } from "../apis";
import { POINT_TWO_FTC_WITH_FEES_TEXT, POINT_TWO_FTC_NO_FEES_TEXT, POINT_TWO_NO_FTC_TEXT, } from "../terms-module";
export var getForecastedPriceDisplayText = function (prediction) {
    if (prediction) {
        var priceToShow = prediction.dealness === Dealness.Wait
            ? prediction.pricePrediction.minPrice
            : prediction.pricePrediction.maxPrice;
        var displayText = priceToShow ? priceToShow.display : "";
        return displayText;
    }
    return "";
};
export var getFtcType = function (policy) {
    var _a, _b;
    switch (((_a = policy === null || policy === void 0 ? void 0 : policy.headline) !== null && _a !== void 0 ? _a : "").toLowerCase()) {
        case UtasPolicyHeadline.ForFree.toLowerCase():
            return FtcType.FtcNoFees;
        case UtasPolicyHeadline.ForAFee.toLowerCase():
            return ((_b = policy === null || policy === void 0 ? void 0 : policy.fee) === null || _b === void 0 ? void 0 : _b.price) && policy.fee.price > 0
                ? FtcType.FtcWithFees
                : FtcType.FtcNoFees;
        case UtasPolicyHeadline.NonRefundable.toLowerCase():
        case UtasPolicyHeadline.NotAllowed.toLowerCase():
            return FtcType.NoFtc;
        default:
            return null;
    }
};
export var getFtcTypeFromCfarOffer = function (offer) {
    var _a;
    switch ((_a = offer.fareRefundability) === null || _a === void 0 ? void 0 : _a.FareRefundability) {
        case "FullFtc":
            return FtcType.FtcNoFees;
        case "PartialFtc":
            return FtcType.FtcWithFees;
        case "NonRefundable":
            return FtcType.NoFtc;
        default:
            return FtcType.NoFtc;
    }
};
export var getFtcTypeArr = function (policies) {
    var ftcTypes = [];
    policies.forEach(function (policy) {
        var ftcType = getFtcType(policy);
        if (ftcType)
            ftcTypes.push(ftcType);
    });
    return ftcTypes;
};
export var secondBulletText = function (_a) {
    var ftcTypes = _a.ftcTypes, cashCoveragePercentage = _a.cashCoveragePercentage, useStrong = _a.useStrong, coMerch = _a.coMerch, refundAmount = _a.refundAmount, airlineFTCAmount = _a.airlineFTCAmount, punctuation = _a.punctuation, excludeWithFeesCopy = _a.excludeWithFeesCopy, concise = _a.concise, isSpiritOrFrontierAirlinesSelected = _a.isSpiritOrFrontierAirlinesSelected, outboundAirlineCode = _a.outboundAirlineCode, returnAirlineCode = _a.returnAirlineCode, showRefundAmountInSecondBulletText = _a.showRefundAmountInSecondBulletText, hasTravelFusionFareBrand = _a.hasTravelFusionFareBrand;
    if (hasTravelFusionFareBrand) {
        return POINT_TWO_NO_FTC_TEXT({
            percent: cashCoveragePercentage,
            useStrong: useStrong,
            coMerch: coMerch,
            refundAmount: refundAmount,
            punctuation: punctuation,
            showRefundAmountInSecondBulletText: showRefundAmountInSecondBulletText,
        });
    }
    if (outboundAirlineCode === "AA" || returnAirlineCode == "AA") {
        return POINT_TWO_NO_FTC_TEXT({
            percent: cashCoveragePercentage,
            useStrong: useStrong,
            coMerch: coMerch,
            refundAmount: refundAmount,
            punctuation: punctuation,
            showRefundAmountInSecondBulletText: showRefundAmountInSecondBulletText,
        });
    }
    if (isSpiritOrFrontierAirlinesSelected) {
        return POINT_TWO_NO_FTC_TEXT({
            percent: cashCoveragePercentage,
            useStrong: useStrong,
            coMerch: coMerch,
            refundAmount: refundAmount,
            punctuation: punctuation,
            showRefundAmountInSecondBulletText: showRefundAmountInSecondBulletText,
        });
    }
    if (ftcTypes.length === 2) {
        if (ftcTypes.includes(FtcType.FtcWithFees) &&
            ftcTypes.includes(FtcType.FtcNoFees)) {
            if (excludeWithFeesCopy) {
                return POINT_TWO_FTC_NO_FEES_TEXT({
                    percent: cashCoveragePercentage,
                    useStrong: useStrong,
                    coMerch: coMerch,
                    refundAmount: refundAmount,
                    airlineFTCAmount: airlineFTCAmount,
                    punctuation: punctuation,
                    concise: concise,
                    showRefundAmountInSecondBulletText: showRefundAmountInSecondBulletText,
                });
            }
            // Since one flight has fees show POINT_TWO_FTC_WITH_FEES_TEXT
            return POINT_TWO_FTC_WITH_FEES_TEXT({
                percent: cashCoveragePercentage,
                useStrong: useStrong,
                coMerch: coMerch,
                refundAmount: refundAmount,
                airlineFTCAmount: airlineFTCAmount,
                punctuation: punctuation,
                concise: concise,
                showRefundAmountInSecondBulletText: showRefundAmountInSecondBulletText,
            });
        }
        if (ftcTypes.includes(FtcType.FtcWithFees) &&
            ftcTypes.includes(FtcType.NoFtc)) {
            return POINT_TWO_NO_FTC_TEXT({
                percent: cashCoveragePercentage,
                useStrong: useStrong,
                coMerch: coMerch,
                refundAmount: refundAmount,
                punctuation: punctuation,
                showRefundAmountInSecondBulletText: showRefundAmountInSecondBulletText,
            });
        }
        if (ftcTypes.includes(FtcType.FtcNoFees) &&
            ftcTypes.includes(FtcType.NoFtc)) {
            return POINT_TWO_NO_FTC_TEXT({
                percent: cashCoveragePercentage,
                useStrong: useStrong,
                coMerch: coMerch,
                refundAmount: refundAmount,
                punctuation: punctuation,
                showRefundAmountInSecondBulletText: showRefundAmountInSecondBulletText,
            });
        }
    }
    else if (ftcTypes.length === 1) {
        switch (ftcTypes[0]) {
            case FtcType.FtcNoFees:
                return POINT_TWO_FTC_NO_FEES_TEXT({
                    percent: cashCoveragePercentage,
                    useStrong: useStrong,
                    coMerch: coMerch,
                    refundAmount: refundAmount,
                    airlineFTCAmount: airlineFTCAmount,
                    punctuation: punctuation,
                    concise: concise,
                    showRefundAmountInSecondBulletText: showRefundAmountInSecondBulletText,
                });
            case FtcType.FtcWithFees:
                if (excludeWithFeesCopy) {
                    return POINT_TWO_FTC_NO_FEES_TEXT({
                        percent: cashCoveragePercentage,
                        useStrong: useStrong,
                        coMerch: coMerch,
                        refundAmount: refundAmount,
                        airlineFTCAmount: airlineFTCAmount,
                        punctuation: punctuation,
                        concise: concise,
                        showRefundAmountInSecondBulletText: showRefundAmountInSecondBulletText,
                    });
                }
                return POINT_TWO_FTC_WITH_FEES_TEXT({
                    percent: cashCoveragePercentage,
                    useStrong: useStrong,
                    coMerch: coMerch,
                    refundAmount: refundAmount,
                    airlineFTCAmount: airlineFTCAmount,
                    punctuation: punctuation,
                    concise: concise,
                    showRefundAmountInSecondBulletText: showRefundAmountInSecondBulletText,
                });
        }
    }
    return POINT_TWO_NO_FTC_TEXT({
        percent: cashCoveragePercentage,
        useStrong: useStrong,
        coMerch: coMerch,
        refundAmount: refundAmount,
        punctuation: punctuation,
        showRefundAmountInSecondBulletText: showRefundAmountInSecondBulletText,
    });
};
export var containsTravelFusionFareSegmentBrand = function (fareDetails) {
    return fareDetails.some(function (detail) {
        return detail.slices.some(function (slice) {
            return slice.fareDetails.segments.some(function (segment) {
                return segment.brand ? "travelFusionFareBrand" in segment.brand : false;
            });
        });
    });
};
export var containsSelfTransferLayoverFareSegment = function (fareDetails) {
    return fareDetails.some(function (detail) {
        return detail.slices.some(function (slice) {
            return slice.fareDetails.segments.some(function (segment) { return segment.isSelfTransferLayover; });
        });
    });
};
//# sourceMappingURL=shopUtils.js.map